





import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class PrivacyPolicy extends Vue {
  public get policyComponent() {
    return () => import(`@/components/privacyPolicy/PrivacyPolicy.${this.$i18n.locale}`);
  }
}
